const arraySetter = (value, oldval) => {
	if (!oldval || !Array.isArray(oldval)) {
		return value
	}

	const newval = oldval.map((x) => x);

	(Array.isArray(value) ? value : [ value ]).forEach(v => {
		const index = oldval.indexOf(v)
		if (-1 !== index) {
			newval.splice(index, 1)
		} else {
			newval.push(v)
		}
	})

	return newval
}

export default arraySetter
